import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@material-ui/core';
import SecurityIcon from '@material-ui/icons/Security';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';

const useStyles = makeStyles(theme => ({
  root: {},
  dialogPaper: {
    borderRadius: 12,
    padding: theme.spacing(3, 2, 2, 2),
    maxWidth: 380,
    width: '100%'
  },
  iconContainer: {
    backgroundColor: '#FFEFE5', // Açık turuncu arka plan
    borderRadius: '50%',
    width: 72,
    height: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px auto'
  },
  icon: {
    fontSize: 36,
    color: '#FF6000' // Ana turuncu renk
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: '15px',
    color: '#000000',
    marginBottom: theme.spacing(1),
    lineHeight: 1.4
  },
  descriptionText: {
    color: '#666666',
    fontSize: '13px',
    marginBottom: theme.spacing(3)
  },
  actions: {
    padding: 0,
    display: 'flex'
  },
  submitButton: {
    flex: 1,
    backgroundColor: '#FF6000',
    color: '#ffffff',
    fontWeight: 'bold',
    borderRadius: 6,
    padding: theme.spacing(1.5, 0),
    textTransform: 'none', // Görseldeki gibi tamamen büyük harf olmasını istemiyorsanız 'none' yapabilirsiniz, görsel büyük harf ise 'uppercase' kalabilir
    boxShadow: 'none',
    marginRight: theme.spacing(1.5), // v4'te gap yerine margin kullanıyoruz
    '&:hover': {
      backgroundColor: '#E65500',
      boxShadow: 'none'
    }
  },
  cancelButton: {
    flex: 1,
    backgroundColor: '#F5F5F7',
    border: '1px solid #E5E5EA',
    color: '#8E8E93',
    fontWeight: 'bold',
    borderRadius: 6,
    padding: theme.spacing(1.5, 0),
    textTransform: 'none',
    marginLeft: '0px !important',
    '&:hover': {
      backgroundColor: '#EAEAEA'
    }
  }
}));

const ExtraWarrantyIncreasePopup = ({ open, job, onClose }) => {
  const classes = useStyles();
  const SessionUser = getUser();
  const sicilNo = SessionUser?.UserId?.toString() || '';

  const handleButtonClick = buttonType => {
    // Log gönder
    if (buttonType && sicilNo && job?.FisNo > 0) {
      axios
        .get(
          `GetArtemisEkgarantiSatisLog/${sicilNo}/${buttonType}/${job?.FisNo}`
        )
        .then(response => {
          // Log başarıyla gönderildi
        })
        .catch(error => {
          console.error('Log gönderilirken hata:', error);
        });
    }

    // Bu fiş için popup gösterildi olarak işaretle
    if (job?.FisNo) {
      localStorage.setItem(`extraWarrantyPopup_${job.FisNo}`, 'true');
    }

    // Popup'ı kapat
    onClose();
  };

  const handleClose = (event, reason) => {
    // Sadece butonlara basıldığında kapanması için backdrop ve escape tuşunu engelle
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="ek-garanti-dialog-title"
      aria-describedby="ek-garanti-dialog-description"
      classes={{ paper: classes.dialogPaper }}
      onClose={handleClose}
    >
      <DialogContent style={{ padding: 0, textAlign: 'center' }}>
        {/* Kalkan İkon Alanı */}
        <div className={classes.iconContainer}>
          <SecurityIcon className={classes.icon} />
        </div>

        {/* Ana Başlık Metni */}
        <Typography variant="body1" className={classes.titleText}>
          Ek garanti satışına uygun ürün tespit edildi!
        </Typography>

        {/* Alt Açıklama Metni */}
        <Typography variant="body2" className={classes.descriptionText}>
          Hemen teklif ederek aylık satış hedefini yakala!
        </Typography>
      </DialogContent>

      {/* Butonlar */}
      <DialogActions className={classes.actions}>
        {/* TEKLİF ET Butonu */}
        <Button
          variant="contained"
          className={classes.submitButton}
          component={RouterLink}
          to={`/WorkOrder/${job?.FisNo}/EkGaranti`}
          onClick={() => handleButtonClick(1)}
        >
          TEKLİF ET
        </Button>

        {/* DAHA SONRA Butonu */}
        <Button
          variant="contained"
          className={classes.cancelButton}
          onClick={() => handleButtonClick(2)}
        >
          DAHA SONRA
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExtraWarrantyIncreasePopup;
